import defaultSettings from '../../config/defaultSettings';

export const NAV_THEME_STORAGE_KEY = 'nav-theme';

export type NavTheme = 'light' | 'realDark';

export function resolveNavTheme(): NavTheme {
  if (typeof window === 'undefined') {
    return defaultSettings.navTheme === 'realDark' ? 'realDark' : 'light';
  }
  try {
    const v = localStorage.getItem(NAV_THEME_STORAGE_KEY);
    if (v === 'light' || v === 'realDark') {
      return v;
    }
  } catch {
    // ignore
  }
  return defaultSettings.navTheme === 'realDark' ? 'realDark' : 'light';
}

/**
 * 在 <html> 上标记当前导航深浅，供全局 CSS 使用（如侧栏浮层等需按深浅分支的样式）。
 */
export function syncNavThemeHtmlClass(nav?: NavTheme): void {
  if (typeof document === 'undefined') {
    return;
  }
  const n = nav ?? resolveNavTheme();
  document.documentElement.classList.toggle('video-ui-nav-dark', n === 'realDark');
}
